import { useGlobal } from '@jimmyboys/liita-ui/dist/components/GlobalContext'

import AlertBox from 'components/AlertBox/AlertBox'

import styles from './TaskRefusalController.module.sass'

const TaskRefusalController = (props) => {
	const { requisition } = props
	const { i18n } = useGlobal()

	return (
		<>
			{requisition?.status?.id === 8 &&
				requisition?.refusalJustification && (
					<AlertBox
						className={styles['alert-box']}
						type='error'
						items={[
							{
								title: i18n`Refusal Reason`,
								text: requisition.refusalJustification,
							},
						]}
					/>
				)}

			{requisition?.status?.id === 11 &&
				requisition?.providerRefusalJustification && (
					<AlertBox
						className={styles['alert-box']}
						type='warning'
						items={[
							{
								title: i18n`Provider Refusal Reason`,
								text: requisition.providerRefusalJustification,
							},
						]}
					/>
				)}
		</>
	)
}

export default TaskRefusalController
